/* assets/product-complete-set.js.liquid */
(function(window, document, utils) {
  'use strict';
  window.SDG = window.SDG || {};
  
  SDG.completeSet = function() {
    var $form = document.getElementById('completeSetForm');
    var $productSection = document.getElementById('completeTheSet');
    
    function init() {
      if (!$productSection) return;
      
      // Simple scrollIntoView with an offset (adjust as needed)
      var scrollElement = document.getElementById('product');
      if (scrollElement) {
        var offset = -50;
        var elementPosition = scrollElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: elementPosition + offset, behavior: 'smooth' });
      }
      
      // Assumes ProductConfigurables and bagForm are defined globally.
      if (window.ProductConfigurables) {
        var productConfigurables = new window.ProductConfigurables({
          productForm: $form,
          productSection: $productSection,
          opts: { id: { addToBag: 'completeSetFormBtn' }, options: { updateButtons: false, modal: false } }
        });
        productConfigurables.init();
      }
      if (window.bagForm) {
        window.bagForm({
          dom: { add_form: 'completeSetForm', bag_btn_text: 'completeSetFormBtn' },
          productData: 'completeSetJson'
        });
      }
    }
    
    init();
  };

})(window, document, window.utils);
